import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';

import AdminUserModal from '../AdminUserModal';
import Link from '../../Link';
import CommonTable from '../../CommonTable/CommonTable';
import CustomPagination from '../../CustomPagination/CustomPagination';
import Loader from '../../Loader/Loader';
import messages from '../../../locale/messages';
import adminUserQuery from './adminUserQuery.graphql';
import adminRolesQuery from './adminRolesQuery.graphql';
import { openAdminUserModal } from '../../../actions/siteadmin/modalActions';
import { deleteAdminUser } from '../../../actions/siteadmin/AdminUser/manageAdminUser';
import { withQuery } from '../../../hoc/withGraphql';
import { censorEmail } from '../../../helpers/secureEmail';
import { decode } from '../../../helpers/queryEncryption';
import { demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';

import s from './AdminUserManagement.css';
import bt from '../../../components/commonStyle.css';
class AdminUserManagement extends React.Component {

  static defaultProps = {
    data: [],
    roles: []
  };

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      searchList: '',
      isRestrict: false,
    }
  }

  async componentDidMount() {
    const { demoRestrictionEncode } = this.props;
    const isRestrict = await demoRestrictionEncode();
    this.setState({ isRestrict });
  }

  handleSearchChange = (searchList) => {
    const { data: { refetch } } = this.props;
    let variables = {
      currentPage: 1,
      searchList,
    };
    this.setState({ searchList, currentPage: 1 });
    refetch(variables);
  }

  handleDelete = async (id, currentPage) => {
    const { deleteAdminUser, setStateVariable, data: { refetch, getAllAdminUsers } } = this.props;
    const { searchList } = this.state;
    let variables = { currentPage: currentPage > 1 && getAllAdminUsers?.results?.length == 1 ? currentPage - 1 : currentPage, searchList };
    const deleteValue = await deleteAdminUser(id, currentPage);
    if (deleteValue?.status === 200) {
      this.setState({ currentPage: variables.currentPage });
      await setStateVariable(variables);
      await refetch(variables);
    }
  }

  handleModalOpen = async (value) => {
    const { openAdminUserModal } = this.props;
    const { isRestrict } = this.state;
    if (value) openAdminUserModal('edit', value, isRestrict)
    else openAdminUserModal('add')
  }

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.sNoLabel) },
      { data: formatMessage(messages.emailLabel) },
      { data: formatMessage(messages.adminRoleLabel) },
      { data: formatMessage(messages.editLabel) },
      { data: formatMessage(messages.delete) }
    ]
  }

  tbody = (props) => {
    const { data: { getAllAdminUsers } } = props;
    const { currentPage, isRestrict } = this.state;

    return getAllAdminUsers?.results?.map((value, key) => {
      return {
        id: key,
        data: [
          { data: key + 1, },
          { data: isRestrict ? censorEmail(decode(value.email)) : decode(value.email) },
          { data: value?.adminRole?.name },
          { data: <Link noLink onClick={() => this.handleModalOpen(value)}><FormattedMessage {...messages.editLabel} /></Link> },
          { data: <Link noLink onClick={() => this.handleDelete(value?.id, currentPage)}><FormattedMessage {...messages.delete} /></Link> }
        ]
      }
    })
  }

  paginationData = (currentPage) => {
    const { data: { refetch } } = this.props;
    const { searchList } = this.state;
    let variables = { currentPage, searchList };
    this.setState({ currentPage, searchList });
    refetch(variables);
  }

  render() {
    const { currentPage } = this.state;
    const { formatMessage } = this.props.intl;
    const { data: { getAllAdminUsers } } = this.props;
    const { adminRoles: { getAllAdminRoles, loading } } = this.props;

    return (
      <div>
        {loading && <div><Loader type={"text"} /></div>}

        {!loading && <div>
          <AdminUserModal roles={getAllAdminRoles} paginationData={this.paginationData} currentPage={currentPage} />
          <CommonTable
            thead={this.thead}
            tbody={() => this.tbody(this.props)}
            isSearch
            isSearchAdd
            handleSearch={(e) => this.handleSearchChange(e?.target?.value)}
            title={formatMessage(messages.manageAdminUsers)}
            addAction={() => this.handleModalOpen()}
            redirectionLabel={formatMessage(messages.addNewLabel)}
          />
          {
            getAllAdminUsers?.count > 0 &&
            <div>
              <CustomPagination
                total={getAllAdminUsers?.count}
                currentPage={currentPage}
                defaultCurrent={1}
                defaultPageSize={10}
                change={this.paginationData}
                paginationLabel={formatMessage(messages.usersLabel)}
              />
            </div>
          }
        </div>}
      </div>
    );
  }
}

const mapState = (state) => ({});

const mapDispatch = {
  openAdminUserModal,
  deleteAdminUser,
  demoRestrictionEncode
};

export default compose(
  injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch),
  withQuery(adminUserQuery, {
    options: (props) => ({
      variables: {
        currentPage: props.currentPage,
        searchList: ''
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  }),
  withQuery(adminRolesQuery, {
    name: 'adminRoles',
    options: {
      fetchPolicy: 'network-only',
      ssr: false
    }
  })
)(AdminUserManagement);